import { useRef } from "react";

/**
 * `true` only while `isLoading` is pending for the first time. Latches to `false` once it has
 * resolved, so a later `isLoading` re-entry (e.g. a react-query key change) can't re-show a
 * one-time loading gate and unmount the subtree it guards.
 */
export function useFirstLoadPending(isLoading: boolean): boolean {
    const hasResolvedRef = useRef(false);
    if (!isLoading) {
        hasResolvedRef.current = true;
    }
    return isLoading && !hasResolvedRef.current;
}
